import { types } from "../types/types";

export const authReducer = ( state = {}, action ) => {
    switch ( action.type ) {
        case types.login:
            return {
                id: action.payload.id,
                name: action.payload.name,
                email: action.payload.email,
                token: action.payload.token,
                available: action.payload.available,
                photoUrl: action.payload.photoUrl,
                phone: action.payload.phone,
                ticketSignature: action.payload.ticketSignature,
                active: action.payload.active,
                role: action.payload.role,
            }
        case types.setAuthAvailability:
            return {
                ...state,
                available: action.payload.available,
            }
        case types.setAuthProfile:
            return {
                ...state,
                ...action.payload,
            }
        case types.logout:
            return {}
        default:
            return state;
    }
}